import React from 'react';

import { useLocation } from 'react-router-dom';

const ScrollTop = () => {
    const { pathname } = useLocation();

    React.useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'auto',
        });
    }, [pathname]);

    return null;
};

export default ScrollTop;
